export type ActivityLiveStatus = {
    isAboutToFinish: boolean;
    isActive: boolean;
    isCollaborationActive: boolean;
    isFinished: boolean;
    isInPast: boolean;
    isLive: boolean;
    // heuristic parameter that indicates start of the session from organizers settings and end time including grace period
    shouldTrackAttendance: boolean;
};
type GetActivityLiveStatus = (
    activityStartTimestamp?: number,
    activityEndTimestamp?: number
) => ActivityLiveStatus;

// TODO: this helper method is bound to Activity too much
// 1. Need to stop using zoned timestamps (as in a timestamp that isn't in UTC)
// 2. Need to extract the grace periods (called offsets here) to a separate helper
export const getActivityLiveStatus: GetActivityLiveStatus = (
    activityStartTimestamp,
    activityEndTimestamp
) => {
    if (
        !activityStartTimestamp ||
        !activityEndTimestamp ||
        Number.isNaN(activityStartTimestamp) ||
        Number.isNaN(activityEndTimestamp)
    ) {
        return {
            isLive: false,
            isActive: false,
            isCollaborationActive: false,
            isInPast: false,
            isFinished: false,
            isAboutToFinish: false,
            shouldTrackAttendance: false,
        };
    }
    const dateNowUTC = Date.now();

    const activationStartOffsetMS = 5 * 60 * 1000;
    const activationEndOffsetMS = 20 * 60 * 1000;
    const aboutToFinishOffset = 1 * 60 * 1000; // one minute in ms
    const collaborationActivationStartOffsetMS = 5 * 60 * 1000; // 5 min before session is live

    const activationStart = activityStartTimestamp - activationStartOffsetMS;
    const activationEnd = activityEndTimestamp + activationEndOffsetMS;

    const activeCollaborationStart = activityStartTimestamp - collaborationActivationStartOffsetMS;
    const activeCollaborationEnd = activationEnd;

    const isLive = dateNowUTC >= activationStart && dateNowUTC <= activityEndTimestamp;
    return {
        isAboutToFinish:
            dateNowUTC <= activationEnd && dateNowUTC >= activityEndTimestamp - aboutToFinishOffset,
        isActive: dateNowUTC >= activationStart && dateNowUTC <= activationEnd,
        isCollaborationActive:
            dateNowUTC >= activeCollaborationStart && dateNowUTC <= activeCollaborationEnd,
        isFinished: dateNowUTC > activityEndTimestamp,
        isInPast: dateNowUTC > activationEnd,
        isLive,
        shouldTrackAttendance: dateNowUTC >= activityStartTimestamp && dateNowUTC <= activationEnd,
    };
};
